import React from 'react'
import Page from '../../../components/View'
import { Tag } from 'antd'
import { ComplementosPagoList } from './list'
import { SinComplementoPagoList } from './sin-complemento'

export default class ComplementosPagoScreen extends React.Component {
  constructor(props) {
    super(props)
    this.state = { tabKey: 'servicios' }
  }

  /**
   * Render
   */
  render() {
    const { tabKey } = this.state
    const tabComprasActive = tabKey === 'compras'
    const tabServiciosActive = tabKey === 'servicios'

    return (
      <Page>
        <div style={{ padding: 25, flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          <div style={{ marginBottom: 25 }}>
            <h1 style={{ margin: 0 }}>Complementos de pago</h1>
            <label>INFORMACIÓN SOBRE PAGOS RECIBIDOS</label>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
            <Tag
              children='PAGOS SIN COMPLEMENTO'
              color={tabServiciosActive ? 'blue' : undefined}
              onClick={() => this.setState({ tabKey: 'servicios' })}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            />

            <Tag
              children='COMPLEMENTOS CARGADOS'
              color={tabComprasActive ? 'blue' : undefined}
              onClick={() => this.setState({ tabKey: 'compras' })}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            />
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              // alignItems
            }}
          >
            {!tabServiciosActive ? null :
              <SinComplementoPagoList />
            }

            {!tabComprasActive ? null :
              <ComplementosPagoList />
            }
          </div>


          {/* <Tabs defaultActiveKey="1" onChange={onTabChange} style={{ marginLeft: 10, marginRight: 10, flex: 1 }}>
            <TabPane tab="COMPRAS" key="1">
              <PagosSolicitadosCxp />
            </TabPane>
            <TabPane tab="SERVICIOS" key="2">
              Content of Tab Pane 2
            </TabPane>
          </Tabs> */}
        </div>
      </Page>
    )
  }
}
